import { SubscribeWidget } from '../../models/SubscribeModel';
import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';
import { SuccessScreen } from './SuccessScreen';
import { SubscribeContent } from './SubscribeContent';
import { useState } from 'react';

interface SubscribePreviewProps {
  // a widget adatai
  subscribeData: SubscribeWidget;
}

export const SubscribePreview = ({ subscribeData }: SubscribePreviewProps) => {
  //@ts-ignore
  const isAdmin = window.isAdminPage;

  const spinningSvgUrl = isAdmin ? '/images/stamp.svg' : '/static_assets/stamp.svg';

  // ha igaz, akkor a sikeres feliratkozás képernyőt mutatja, egyébként a formot
  const [success, setSuccess] = useState(false);

  return (
    <div className='flex justify-center  min-h-[200px] mx-auto w-full h-full previewScrollbar min-[350px]:overflow-y-auto min-[350px]:overflow-x-hidden sm:overflow-hidden '>
      <style>{previewScrollbar}</style>
      <div
        className='flex justify-center min-[350px]:py-4 md:py-6 lg:py-10 min-[350px]:px-4 md:px-6 lg:px-10 relative min-[350px]:items-start sm:items-center mx-auto w-full'
        style={{ background: subscribeData.backgroundColor }}
      >
        <div className='w-full max-w-[1240px] relative rounded flex p-4 mx-auto bg-white'>
          {!success && <SubscribeContent textColor={subscribeData.textColor} buttonColor={subscribeData.buttonColor} buttonTextColor={subscribeData.buttonTextColor} setSuccess={setSuccess} />}
          {success && <SuccessScreen textColor={subscribeData.textColor} />}
          <img className='absolute -right-8 -bottom-8 w-[120px] h-[120px] min-[350px]:hidden lg:flex' src={spinningSvgUrl} alt='subscribeLogo' />
        </div>
      </div>
    </div>
  );
};
